<template>
  <div
    class="inline-loader"
    :class="{
      _loading: active,
    }"
  >
    <!-- 3 dots for the loading animation -->
    <div class="dots">
      <span class="dot" />
      <span class="dot" />
      <span class="dot" />
    </div>
  </div>
</template>

<script setup lang="ts">
// Props
interface Props {
  active?: boolean;
}

const { active = true } = defineProps<Props>();
</script>

<style lang="scss">
@import "@styles/layout/z-map";
@import "@styles/themes/sls-theme/tokens/colors";
@import "@styles/themes/sls-theme/tokens/spacing";

.inline-loader {
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  background-color: $overlay-01;
  z-index: z-map("inline-loader");
  display: none;

  &._loading {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .dots {
    display: flex;
    position: absolute;
    width: 24px;
    height: 24px;
    justify-content: center;
    align-items: center;
    z-index: 1;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }

  .dot {
    height: 3px;
    width: 3px;
    background-color: $interactive-01;
    border-radius: 100%;
    animation: loading 2s ease-in-out infinite;

    &:nth-child(2) {
      animation-delay: 0.4s;
      margin: $spacing-02;
    }

    &:nth-child(3) {
      animation-delay: 0.8s;
    }
  }

  @keyframes loading {
    50% {
      opacity: 0.5;
      transform: scale(3) translateY(-1.5px);
    }
  }
}
</style>
